import React, { useEffect, useState } from 'react';
import useRouter from "./../../hooks/useRouter";
import { connect } from "react-redux";
import LoginBoxSelfCheckin from '../../components/LoginBox/LoginBoxSelfCheckin';
import SelfCheckinHeader from "./Header/SelfCheckinHeader";
import { ToastContainer, toast } from 'react-toastify';
import {Dimmer, Grid, Loader, Divider} from 'semantic-ui-react';
import API, {ErrorManagement, ResponseManagement} from "../../API";
import ErrorEstablishmentNotFound from "../ErrorEstablishmentNotFound/ErrorEstablishmentNotFound";
import DropdownLangueSelfCheckin from "../../components/Navigation/DropdownLangueSelfCheckin/DropdownLangueSelfCheckin";
import "./LoginPageSelfCheckin.css";

const mapProps = (state) => ({
  hasModule: state.authentication.hasModule,
})

const mapDispatch = (dispatch) => ({
  setAuthenticationInfos: dispatch.authentication.setAuthenticationInfos
})



/**
 * Chargement page Self CheckIn
 */
const LoginPageSelfCheckin = (props) => {
  const [establishmentState, setEstablishmentState] = useState({});
  const [languagesState, setLanguageState] = useState([]);
  const [translationsState, setTranslationsState] = useState({});
  const [loaderActiveState, setLoaderActiveState] = useState(true);
  //const [reponseState, setReponseState] = useState(true);

  // Router
  const router = useRouter();

  //loading translations & establishment infos
  useEffect(() => {
    let url = "";

    if (typeof props.match.params.lang === "undefined" || (typeof props.match.params.lang !== "undefined" && ["FR", "EN", "DE", "IT", "ES"].indexOf(props.match.params.lang) === -1)) {
      url = `/${props.match.params.token}/FR/getInfosSelfCheckin`;
      //router.history.push(`/${props.match.params.token}/FR/selfCheckin`);
      router.navigate( `/${props.match.params.token}/FR/selfCheckin` );
    } else {
      url = `/${props.match.params.token}/${props.match.params.lang}/getInfosSelfCheckin`
    }

    API
      .get(url)
      .then(response => {
        ResponseManagement(response,
          () => {
            setLoaderActiveState(false);
            //displayControl 
            //TODO : ajouter verif ip ici
            if (response?.data?.data?.displayControl?.selfCheckinModule) {
              setLoaderActiveState(false);
              // authenticationStatus, hasMdp n'ont pas d'importance pour le selfCheckin
              let authObject = {
                authenticationStatus: 2,
                hasMdp: false,
                hasModule: response.data.data.hasModule,
              }
              props.setAuthenticationInfos(authObject);

              if (response?.data?.data?.hasModule) {
                setEstablishmentState(response.data.data.establishment);
                setTranslationsState(response.data.data.translations);
                setLanguageState(response.data.data.languages);
              }
            }
            else{
              //router
              //setLoaderActiveState(false);
              //router.push(``);
            }
            
          },
          () => {
            setLoaderActiveState(false);
         }
        );
      })
      .catch( error => {
        ErrorManagement(error, () => {
          setLoaderActiveState(false);
        });
      })
  }, [props.match.params.token, props.match.params.lang]);

  let backgroundImage = {
    backgroundImage: "url('" + ((establishmentState && establishmentState.backgroundImage) ? establishmentState.backgroundImage : null) + "')"
  }

  const getContent = () => {
    let tabContent = [];

    if (loaderActiveState) {
      tabContent.push(null);
    } else if (Object.keys(establishmentState).length > 0) {
      tabContent.push(
        <div key="selfCheckin" style={{height: "100%"}}>
          <div style={backgroundImage} className="selfCheckinBackgroundContainer"/>
            <Grid style={{height: "100%"}} className="selfCheckinGridContainer" textAlign="center" verticalAlign="middle">
              <Grid.Column className="selfCheckinContentContainer">
                <div className="selfCheckinContent">
                  {
                    Object.keys(languagesState).length > 0 &&
                      <>
                        <DropdownLangueSelfCheckin languages={languagesState} translations={translationsState}/>
                        <SelfCheckinHeader languages={languagesState} infosEstablishment={establishmentState}
                                         translations={translationsState}/>
                        <Divider/>
                      </>
                  }
                  { props.hasModule &&
                    <LoginBoxSelfCheckin languages={languagesState} infosEstablishment={establishmentState} translations={translationsState}/>
                  }
                </div>
              </Grid.Column>
            </Grid>
        </div>
      );
    } else {
      tabContent.push(<ErrorEstablishmentNotFound key='establishmentNotFound'/>);
    }

    return tabContent;
  }

  return (
    <Dimmer.Dimmable as={'div'} dimmed={loaderActiveState} style={{height: "100vh", position: "initial"}}>
      <Dimmer active={loaderActiveState} inverted>
        <Loader>Loading</Loader>
      </Dimmer>
      {getContent()}
      <ToastContainer enableMultiContainer position="bottom-right"/>
    </Dimmer.Dimmable>
  )
}
export default connect(mapProps, mapDispatch)(LoginPageSelfCheckin);